export async function accountRequest(path, options = {}) {
    const response = await fetch(path, {
        method: options.method || "GET",
        credentials: "include",
        headers: {
            ...(options.body ? { "content-type": "application/json" } : {}),
            ...(options.headers || {}),
        },
        body: options.body ? JSON.stringify(options.body) : undefined,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.ok === false) {
        const error = new Error(payload.message || "Request failed.");
        error.status = response.status;
        error.payload = payload;
        throw error;
    }
    return payload;
}

export function firstName(nameOrEmail) {
    const value = String(nameOrEmail || "").trim();
    if (!value) return "there";
    const name = value.includes("@") ? value.split("@")[0] : value;
    return name.split(/\s+/)[0] || "there";
}
